import { useTranslation } from "react-i18next"

import type { Tower } from "types/towers.types"

import DetailsGroupsCard from "widgets/common/DetailsGroupsCard"
import { getTowerDetailsGroups } from "helpers/utils/towers"

interface TowerDetailsProps {
  tower: Tower
}

const TowerDetails = ({ tower }: TowerDetailsProps) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.resolvedLanguage ?? "en"

  return (
    <DetailsGroupsCard
      titleKey="tower_information.TOWER_DETAILS"
      groups={getTowerDetailsGroups(tower, locale, t)}
    />
  )
}

export default TowerDetails
